<template>
	<inertia-head title="Old Members Epay Payment" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Old Members Epay Payment</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Old Members Epay Payment
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4">
									<div class="mb-4">
										<label for="status" class="form-label">Status</label>
										<select v-model="form.status" id="status" name="status" class="form-select form-select-sm">
											<option value="">ALL</option>
											<option value="1">Active</option>
											<option value="0">Expired</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="mb-4">
										<label for="status" class="form-label">Payment Transfer</label>
										<select v-model="form.payment_transfer" id="status" name="status" class="form-select form-select-sm">
											<option value="">ALL</option>
											<option value="1">Yes</option>
											<option value="0">No</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="mb-4">
										<label for="status" class="form-label">Transfer Status</label>
										<select v-model="form.payment_transfer_status" id="status" name="status" class="form-select form-select-sm">
											<option value="">ALL</option>
											<option value="Cancelled">Cancelled on ePay</option>
											<option value="Pending">Pending</option>
										</select>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="mb-4">
										<label for="filterByColumn" class="form-label">Filter by</label>
										<select name="filterByColumn"
											v-model="form.filterByColumn"
											class="form-select form-select-sm"
										>
											<option value="m.username">Email</option>
											<option value="m.fname">First Name</option>
											<option value="m.lname">Last Name</option>
											<option value="m.current_rank">Membership Level</option>
											<option value="m.counter">User ID</option>
											<option value="m.mobile">Mobile Number</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="mb-4">
										<label for="columnValue" class="form-label">Value</label>
										<input
											name="columnValue"
											v-model="form.columnValue"
											type="text"
											class="form-control form-control-sm"
										/>
									</div>
								</div>
								<div class="col-md-4">
									<div class="mb-4 pt-4">
										<button
											type="submit"
											class="btn btn-alt-primary"
											:disabled="form.processing"
										>
											<div
												v-if="form.processing"
												class="spinner-border spinner-border-sm text-dark"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
											<span v-else>
												<i class="fa fa-search me-1"></i>
											</span>
											Search
										</button>
										<button
											@click="
												$inertia.get(route('admin.user-management.members.index'))
											"
											type="button"
											class="btn btn-alt-secondary"
										>
											Reset
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>#</th>
								<th>USERID</th>
								<th>MEMBERSHIP</th>
								<th>EXPIRY</th>
								<th>FULLNAME</th>
								<th>EMAIL</th>
								<th>TRANSFERED</th>
								<th>STATUS</th>
							</tr>
						</thead>
						<tbody v-if="members.data.length > 0" class="fs-sm">
							<tr
								v-for="(member, index) in members.data"
								:key="member.counter"
							>
								<td>{{ index + members.from }}</td>
								<td>
									<inertia-link
										:href="
											route(
												'admin.user-management.members.show',
												member.member_uuid
											)
										"
										class="fw-semibold text-info"
									>
										{{ member.counter }}
										<i class="fa fa-arrow-right"></i>
									</inertia-link>
								</td>
								<td data-title="Membership:">{{ member.current_rank }}</td>
								<td data-title="Expiry:">
									<h6 class="fw-semibold fs-xs mb-0">{{ member.expiry }}</h6>
									<small
										:class="
											member.daysRemaining > 7 ? 'text-success' : 'text-danger'
										"
									>
										{{
											member.daysRemaining <= 0
												? 'Expired'
												: `${member.daysRemaining} ${member.daysRemainingStr} remaining`
										}}
									</small>
								</td>
								<td data-title="Fullname:">
									{{ member.full_name }}
									<div><sub class="text-elegance">Mobile#:{{member.mobile}}</sub></div>
								</td>
								<td data-title="Email:">{{ member.email }}</td>
								<td>
									<span :class="{'text-success':member.payment_transfer==1,'text-danger':member.payment_transfer==0}">{{member.payment_transfer_format}}</span>
								</td>
								<td>
									<span :class="{'text-danger':member.payment_transfer_status=='Cancelled','text-warning':member.payment_transfer_status=='Pending'}">{{member.payment_transfer_status}}</span>
									<div>
										<button @click="updateStatus(index)" type="button" class="btn btn-sm btn-outline-info fs-xs p-0 px-1"><i class="fa fa-edit me-1"></i>Update</button>
									</div>
								</td>
							</tr>
						</tbody>
						<tbody v-else class="fs-sm">
							<tr>
								<th colspan="8" class="text-center">NO RECORD FOUND</th>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="members" />
			</div>
		</div>


		<modal ref="updateStatusModal">
			<template #title>ePay Status</template>
			<template #body>
				<div class="form-group mb-2">
					<label>Email</label>
					<div class="form-control">{{formSelected.email}}</div>
				</div>
				<div class="form-group mb-2">
					<label>Transfer</label>
					<div class="form-control">{{formSelected.payment_transfer_format}}</div>
				</div>
				<div class="form-group mb-2">
					<label>Status</label>
					<select v-model="formSelected.payment_transfer_status" class="form-select">
						<option value="Cancelled">Cancelled on ePay</option>
						<option value="Pending">Pending</option>
					</select>
				</div>
			</template>
			<template #footer>
				<button @click="confirmUpdateStatus" type="button" class="btn btn-alt-success" :disabled="formSelected.processing">
					<div
						v-if="formSelected.processing"
						class="spinner-border spinner-border-sm text-dark me-1"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<i v-else class="fa fa-save me-1"></i>
					<span>SAVE</span>
				</button>
				<button @click="updateStatusModal.toggleModal" type="button" class="btn btn-alt-secondary">
					<i class="fa fa-times me-1"></i>CLOSE
				</button>
			</template>
		</modal>


	</div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		members: Object,
		filters: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const updateStatusModal = ref(null);

		const form = useForm({
			filterByColumn 				: props.filters.filterByColumn ? props.filters.filterByColumn : 'username',
			columnValue 				: props.filters.columnValue,
			status 						: props.filters.status ? props.filters.status : '',
			payment_transfer 			: props.filters.payment_transfer ? props.filters.payment_transfer : '',
			payment_transfer_status 	: props.filters.payment_transfer_status ? props.filters.payment_transfer_status : '',
		})

		const formSelected = useForm({
			username 				: '',
			payment_transfer 		: '',
			payment_transfer_status : '',
		})

		const updateStatus = (_index)=>{

			formSelected.member_id 					= props.members.data[_index].counter;
			formSelected.email 						= props.members.data[_index].email;
			formSelected.payment_transfer_format 	= props.members.data[_index].payment_transfer_format;
			formSelected.payment_transfer_status 	= props.members.data[_index].payment_transfer_status;

			updateStatusModal.value.toggleModal();
		}

		const confirmUpdateStatus = ()=>{

			formSelected.put('epay-payment/'+formSelected.member_id, {
				preserveState: true,
				preserveScroll: true,
				only:['filters,members'],
				onSuccess: ()=>{
					updateStatusModal.value.toggleModal();
				}
			})
		}

		const submit = () => {
			form.get(route('admin.user-management.epay-payment'), {
				preserveState: true,
				preserveScroll: true,
				only:['filters,members'],
			})
		}

		return {
			updateStatusModal,
			form,
			formSelected,
			updateStatus,
			confirmUpdateStatus,
			submit,
		}
	},
}
</script>
